import angular from 'angular';
import moment from 'moment';
import Promise from 'bluebird';
import uiRouter from 'angular-ui-router';
import routing from './formation.routes';
import uuidv4  from 'uuid/v4';

export class FormationController {
  users = [];
  newThing = '';

  /*@ngInject*/
  constructor($http, $scope, $rootScope, $location, $timeout, $stateParams, $filter, appConfig, toastr, Upload, Traduction) {
    var vm = this
    vm.orderBy = "client"
    vm.reverseSort = false
    vm.availableImages = ['jpg', 'JPG', 'png', 'PNG']
    vm.availableVideos = ['mp3', 'mp4', 'wmv', 'mkv', 'avi']

    $http.get(`/api/formations/${$stateParams.id}`).then(response => {
      vm.formation = response.data;
      console.log(vm.formation)
      $rootScope.siteId = vm.formation.Categorie.Poste.siteId
      $rootScope.posteId = vm.formation.Categorie.posteId
      $rootScope.categorieId = vm.formation.categorieId
      /*vm.formation.years = Math.floor(vm.formation.expiryDate / 365)
      vm.formation.mounths = Math.floor(vm.formation.expiryDate / 30) - (Math.floor(vm.formation.years * 12))*/
      vm.data = angular.copy(vm.formation)
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    });

    //////////////////////////// SUPPORTS ////////////////////////////////////
    vm.createSupport = function(){
      vm.data = {};
      vm.data.langues = [];
      vm.create = true;

      _.forEach(vm.formation.Categorie.langues, function(langueCategorie){
        var langue = _.find(vm.formation.Categorie.Poste.Site.langues, ['id', langueCategorie]);
        var currentLangue = _.find(vm.data.langues, ['langueId', langueCategorie]);
        if(_.map(vm.data.langues, 'langueId').includes(langueCategorie)) currentLangue.name = langue.name;
        if(langue && !_.map(vm.data.langues, 'langueId').includes(langueCategorie)) vm.data.langues.push({name : langue.name, langueId : langue.id});
      });
      vm.data.rank = vm.formation.supports == null ? 0 : vm.formation.supports.length;
      vm.data.id = uuidv4();
      vm.data.type = 'media';
      $('#addSupport').modal("show");
    }

    vm.editSupport = function(support){
      vm.data = support;
      _.forEach(vm.formation.Categorie.langues, function(langueCategorie){
        var langue = _.find(vm.formation.Categorie.Poste.Site.langues, ['id', langueCategorie]);
        var currentLangue = _.find(vm.data.langues, ['langueId', langueCategorie]);
        if(_.map(vm.data.langues, 'langueId').includes(langueCategorie)) currentLangue.name = langue.name;
        if(langue && !_.map(vm.data.langues, 'langueId').includes(langueCategorie)) vm.data.langues.push({name : langue.name, langueId : langue.id});
      });
      vm.create = false;
      if(vm.data.type == 'gSlide') $scope.gSlideLink = vm.data.media;
      if(vm.data.type == 'media') vm.source = `${appConfig.baseUrl}/public/postes/${vm.formation._id}/supports/${vm.data.media}`;
      $('#addSupport').modal("show");
    }

    vm.saveSupport = function() {
      $scope.clicked = true;
      if (vm.data.type == 'gSlide') {
        _.map(vm.data.langues, function(langue){
          langue.gSlideLink= langue.gSlideLink.replace('/pub?','/embed?');
          langue.gSlideLink= langue.gSlideLink.replace('?start=false','?start=true');
          langue.gSlideLink= langue.gSlideLink.replace('?loop=true','?loop=false');
          langue.file = undefined;
        })
      }
      if(vm.create) vm.formation.supports.push(vm.data)
      Promise.map(vm.data.langues, function(langue){
        return uploadMass(langue, vm.data.id)
      }).then(function(resp){
        $scope.clicked = false;
        $http.patch(`/api/formations/${vm.formation._id}`, {supports : vm.formation.supports}).then(response => {
          $http.get(`/api/formations/${vm.formation._id}`).then(resp => {
            vm.formation = resp.data;
            $scope.clicked = false;
            vm.uploadPercent = 0;
            $('#addSupport').modal('hide');
          }).catch(err => {
            console.log(err);
            vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
            vm.uploadPercent = 0;
            $scope.clicked = false;
          });
        });
      });
    }

    vm.deleteSupport = function(data) {
      vm.supportToDelete = data
      $('#deleteSupport').modal('show')
    }

    vm.validateDeleteSupport = function() {
      $scope.clicked = true;
      vm.formation.supports.splice(vm.formation.supports.indexOf(vm.supportToDelete), 1);
      $http.patch(`/api/formations/${vm.formation._id}`, vm.formation).then(response => {
        $http.get(`/api/formations/${vm.formation._id}`).then(response => {
          vm.formation = response.data;
          $('#deleteSupport').modal('hide');
          $scope.clicked = false;
        });
      }).catch(err => {
        console.log(err);
        vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
        $scope.clicked = false;
      }); 
    }

    //////////////////////////// QUESTIONS ////////////////////////////////////
    vm.createQuestion = function(){
      vm.data = {};
      vm.data.langues = [];
      vm.create = true;
      _.forEach(vm.formation.Categorie.langues, function(langueCategorie){
        var langue = _.find(vm.formation.Categorie.Poste.Site.langues, ['id', langueCategorie]);
        var currentLangue = _.find(vm.data.langues, ['langueId', langueCategorie]);
        if(_.map(vm.data.langues, 'langueId').includes(langueCategorie)) currentLangue.name = langue.name;
        if(langue && !_.map(vm.data.langues, 'langueId').includes(langueCategorie)) vm.data.langues.push({name : langue.name, langueId : langue.id, reponses : []});
      });
      vm.data.rank = vm.formation.questions == null ? 0 : vm.formation.questions.length;
      vm.data.id = uuidv4();
      vm.data.type = 'texte';
      vm.data.anwserCount = 3;
      $('#addQuestion').modal("show");
    }

    vm.editQuestion = function(question){
      vm.data = question;
      _.forEach(vm.formation.Categorie.langues, function(langueCategorie){
        console.log(langueCategorie)
        var langue = _.find(vm.formation.Categorie.Poste.Site.langues, ['id', langueCategorie]);
        var currentLangue = _.find(vm.data.langues, ['langueId', langueCategorie]);
        if(_.map(vm.data.langues, 'langueId').includes(langueCategorie)) currentLangue.name = langue.name;
        if(langue && !_.map(vm.data.langues, 'langueId').includes(langueCategorie)) vm.data.langues.push({name : angular.copy(langue.name), langueId : angular.copy(langue.id), reponses : angular.copy(vm.data.langues[0].reponses)});
      });
      vm.create = false;
      $('#addQuestion').modal("show");
    }

    vm.saveQuestion = function() {
      $scope.clicked = true;
      _.forEach(vm.data.langues, function(langue){
        _.forEach(langue.reponses, function(reponse, index){
          reponse.number = index;
        })
      })
      if(vm.create) vm.formation.questions.push(vm.data);
      return uploadQuestion(vm.data).then(function(resp){
        return Promise.all(_.flatMap(vm.data.langues, function(langue){
          return _.map(langue.reponses, function(reponse, index){
            return uploadMass(_.merge(reponse,{langueId : langue.langueId}), vm.data.id + '_reponse_' + index);
          })
        })
      )}).then(function(resp){
        $scope.clicked = false;
        $http.patch(`/api/formations/${vm.formation._id}`, {questions : vm.formation.questions}).then(response => {
          $http.get(`/api/formations/${vm.formation._id}`).then(resp => {
            vm.formation = resp.data;
            vm.data = {};
            $scope.clicked = false;
            vm.uploadPercent = 0;
            $('#addQuestion').modal('hide');
          }).catch(err => {
            console.log(err);
            vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
            vm.uploadPercent = 0;
            $scope.clicked = false;
          });
        });
      });
    }

    vm.changeAllReponses = function(reponse, index){
      _.forEach(vm.data.langues, function(langue){
        langue.reponses[index].correcte = reponse.correcte;
      });
    }

    $scope.$watch('vm.data.anwserCount', function(newV, oldV){
      if(vm.data && vm.data.anwserCount) {
        for(var i = 0; i < vm.data.anwserCount; i++) {
          _.forEach(vm.data.langues, function(langue, index){
            if(vm.data.langues[index].reponses[i] == undefined) {
              vm.data.langues[index].reponses[i] = {};
            } else if(vm.data.langues[index].reponses.length > vm.data.anwserCount) {
              vm.data.langues[index].reponses = vm.data.langues[index].reponses.slice(0, vm.data.anwserCount);
            };
          });
        };
      };
    });

    vm.deleteMedia = function() {
      vm.data.media = undefined;
    };

    vm.deleteQuestion = function(data) {
      vm.questionToDelete = data;
      $('#deleteQuestion').modal('show');
    };

    vm.validateDeleteQuestion = function() {
      $scope.clicked = true
      vm.formation.questions.splice(vm.formation.questions.indexOf(vm.questionToDelete), 1);
      $http.patch(`/api/formations/${vm.formation._id}`, vm.formation).then(response => {
        $http.get(`/api/formations/${vm.formation._id}`).then(response => {
          vm.formation = response.data;
          $('#deleteQuestion').modal('hide');
          $scope.clicked = false;
        });
      }).catch(err => {
        console.log(err);
        vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
        $scope.clicked = false;
      }); 
    }

    vm.cancelEdit = function(){
      vm.data = {};
      $('#addSupport').modal('hide');
      $('#addQuestion').modal('hide');
    }

    vm.save = function(){
      $scope.clicked = true
      $http.patch(`/api/formations/${vm.formation._id}`, vm.formation).then(function(){
        toastr.success($filter('translate')('saved'), $filter('translate')('terminalUpdated'));
        $scope.clicked = false
      })
    }

    vm.errorFile = function(file, data, accepted){
      vm.accepted = accepted
      if(!accepted.includes(file.type)) {
        $('#errorFile').modal('show')
        $scope.$apply();
      } else {
        data.file = file
      }
    }

    // $('.dd').nestable();
    $('#listSupports').nestable({group : 0});
    $('#listQuestions').nestable({group : 1});
    $('#listSupports').on('change', function() {
      update_out('#listSupports', 'supports');
    });
    $('#listQuestions').on('change', function() {
      update_out('#listQuestions','questions');
    });

    function update_out(selector, objet){
      vm.loading = true;
      var out = $(selector).nestable('serialize');
      vm.sortedList = []
      _.forEach(out, function(ligne, index){
        if(ligne.id && ligne.id != '')vm.sortedList.push(_.assignIn(_.find(vm.formation[objet], {id : ligne.id}),{rank : index}));
      })
      vm.formation[objet] = angular.copy(vm.sortedList);
      $http.patch(`/api/formations/${vm.formation._id}`, {[objet] : vm.formation[objet]}).then(response => {
        $http.get(`/api/formations/${vm.formation._id}`).then(response => {
          vm.formation = response.data;
          vm.formation.expiryDate = moment(vm.formation.expiryDate).format('YYYY-MM-DD');
          vm.loading = false;
          vm.data = {};
        });
      })
    }

    function uploadMass (langue, parent) {
      return new Promise(function(resolve, reject){
        if(langue.file) {
          Upload.upload({
              url: `/api/formations/${vm.formation._id}`,
              data: {file: langue.file, path : langue.langueId, name : parent}
          }).then(function (resp) {
            langue.mediaPath = resp.data
            langue.file = undefined
            console.log('hi')
            return resolve(langue)
          }, function (resp) {
            return reject()
            $scope.clicked = false
            console.log('Error status: ' + resp.status);
          }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            vm.uploadPercent = parseInt(90.0 * evt.loaded / evt.total);
          });
        } else {
          return resolve()
        }
      })
    };

    function uploadQuestion (langue, question) {
      return new Promise(function(resolve, reject){
        console.log(langue)
        if(langue.file) {
          Upload.upload({
              url: `/api/formations/${vm.formation._id}`,
              data: {file: langue.file, path : 'questions', name : langue.id}
          }).then(function (resp) {
            langue.mediaPath = resp.data
            langue.file = undefined
            return resolve(langue)
          }, function (resp) {
            return reject()
            $scope.clicked = false
            console.log('Error status: ' + resp.status);
          }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            vm.uploadPercent = parseInt(90.0 * evt.loaded / evt.total);
          });
        } else {
          return resolve()
        }
      })
    };
  }
}

export default angular.module('aperamApp.formation', [uiRouter])
  .config(routing)
  .component('formation', {
    template: require('./formation.html'),
    controller: FormationController,
    controllerAs:'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/formation/formation.component.js